export const state = {
    NCM: {},
    NCMs: [],
    modalExcluirNCM: false,
    modalCadastrarNCM: false,
    modalAtualizarTabelaNCM: false,
}

export default {}